export var EVENT = /* @__PURE__ */ ((EVENT2) => {
  EVENT2["UNHANDLED_ERROR"] = "unhandled_error";
  EVENT2["UNHANDLED_SERVICE_ERROR"] = "unhandled_service_error";
  EVENT2["UNHANDLED_SUCCESS_ERROR"] = "unhandled_success_error";
  EVENT2["SOFT_UNHANDLED_ERROR"] = "soft_unhandled_error";
  EVENT2["CLIENT_UNHANDLED_ERROR"] = "client_unhandled_error";
  EVENT2["CLIENT_UNHANDLED_SERVICE_ERROR"] = "client_unhandled_service_error";
  EVENT2["CLIENT_SOFT_UNHANDLED_ERROR"] = "client_soft_unhandled_error";
  EVENT2["CLIENT_FEATURE_TOGGLE"] = "client_feature_toggle";
  return EVENT2;
})(EVENT || {});
export var BUYER_EVENT = /* @__PURE__ */ ((BUYER_EVENT2) => {
  BUYER_EVENT2["CHECKOUT_CANCEL"] = "onetext_checkout_cancel";
  BUYER_EVENT2["CHECKOUT_FINALIZE"] = "onetext_checkout_finalize";
  BUYER_EVENT2["CHECKOUT_PREORDER"] = "onetext_checkout_preorder";
  BUYER_EVENT2["CHECKOUT_REFUND"] = "onetext_checkout_refund";
  BUYER_EVENT2["CHECKOUT_REFUND_DELAY"] = "onetext_checkout_refund_delay";
  BUYER_EVENT2["CHECKOUT_REFUND_ERROR"] = "onetext_checkout_refund_error";
  BUYER_EVENT2["CHECKOUT_SETUP"] = "onetext_checkout_setup";
  BUYER_EVENT2["CHECKOUT_UPDATE"] = "onetext_checkout_update";
  BUYER_EVENT2["EMAIL_OPT_IN"] = "onetext_email_opt_in";
  BUYER_EVENT2["EXPERIMENT_START"] = "onetext_experiment_start";
  BUYER_EVENT2["EXPERIMENT_END"] = "onetext_experiment_end";
  BUYER_EVENT2["EXTERNAL_CART_CREATE"] = "onetext_external_cart_create";
  BUYER_EVENT2["EXTERNAL_CART_UPDATE"] = "onetext_external_cart_update";
  BUYER_EVENT2["EXTERNAL_CHECKOUT_CREATE"] = "onetext_external_checkout_create";
  BUYER_EVENT2["EXTERNAL_CHECKOUT_UPDATE"] = "onetext_external_checkout_update";
  BUYER_EVENT2["EXTERNAL_ORDER_CREATE"] = "onetext_external_order_create";
  BUYER_EVENT2["EXTERNAL_ORDER_SHIPPED"] = "onetext_external_order_shipped";
  BUYER_EVENT2["EXTERNAL_ORDER_UPDATE"] = "onetext_external_order_update";
  BUYER_EVENT2["EXTERNAL_PRODUCT_VIEW"] = "onetext_external_product_view";
  BUYER_EVENT2["EXTERNAL_BROWSE"] = "onetext_external_browse";
  BUYER_EVENT2["LINK_CLICK"] = "onetext_link_click";
  BUYER_EVENT2["LINK_CLICK_BOT"] = "onetext_link_click_bot";
  BUYER_EVENT2["SMS_OPT_IN"] = "onetext_sms_opt_in";
  BUYER_EVENT2["SMS_OPT_IN_REQUEST"] = "onetext_sms_opt_in_request";
  BUYER_EVENT2["SMS_OPT_OUT"] = "onetext_sms_opt_out";
  BUYER_EVENT2["SMS_RESPONSE"] = "onetext_sms_response";
  BUYER_EVENT2["NET_NEW_SMS_OPT_IN"] = "onetext_net_new_sms_opt_in";
  BUYER_EVENT2["NET_NEW_EMAIL_OPT_IN"] = "onetext_net_new_email_opt_in";
  BUYER_EVENT2["MESSAGE_OUTBOUND"] = "onetext_message_outbound";
  BUYER_EVENT2["MESSAGE_INBOUND"] = "onetext_message_inbound";
  BUYER_EVENT2["SUBSCRIPTION_ACTIVATE"] = "onetext_activate_subscription";
  BUYER_EVENT2["SUBSCRIPTION_CANCEL"] = "onetext_subscription_cancel";
  BUYER_EVENT2["VAULT_FINALIZE"] = "onetext_vault_finalize";
  BUYER_EVENT2["FLOW_START"] = "onetext_flow_start";
  BUYER_EVENT2["POPUP_PAGE_RENDER"] = "onetext_popup_page_render";
  BUYER_EVENT2["POPUP_TEASER_RENDER"] = "onetext_popup_teaser_render";
  BUYER_EVENT2["POPUP_SMS_OPT_IN"] = "onetext_popup_sms_opt_in";
  BUYER_EVENT2["POPUP_EMAIL_OPT_IN"] = "onetext_popup_email_opt_in";
  BUYER_EVENT2["POPUP_NET_NEW_SMS_OPT_IN"] = "onetext_popup_net_new_sms_opt_in";
  BUYER_EVENT2["POPUP_NET_NEW_EMAIL_OPT_IN"] = "onetext_popup_net_new_email_opt_in";
  BUYER_EVENT2["POPUP_QUIZ_RESULT"] = "onetext_popup_quiz_result";
  BUYER_EVENT2["PAGE_VIEW"] = "onetext_page_view";
  return BUYER_EVENT2;
})(BUYER_EVENT || {});
export var POPUP_VISIBILITY = /* @__PURE__ */ ((POPUP_VISIBILITY2) => {
  POPUP_VISIBILITY2["NOT_LIVE"] = "not_live";
  POPUP_VISIBILITY2["SHOWN"] = "shown";
  POPUP_VISIBILITY2["SUPPRESSED"] = "suppressed";
  POPUP_VISIBILITY2["ALREADY_SEEN"] = "already_seen";
  return POPUP_VISIBILITY2;
})(POPUP_VISIBILITY || {});
export const BuyerEventToSegmentLabel = {
  ["onetext_external_cart_create" /* EXTERNAL_CART_CREATE */]: "created a cart",
  ["onetext_external_checkout_create" /* EXTERNAL_CHECKOUT_CREATE */]: "started a website checkout",
  ["onetext_external_order_create" /* EXTERNAL_ORDER_CREATE */]: "placed an order",
  ["onetext_link_click" /* LINK_CLICK */]: "clicked a link",
  ["onetext_sms_opt_in" /* SMS_OPT_IN */]: "opted into SMS",
  ["onetext_sms_opt_out" /* SMS_OPT_OUT */]: "opted out of SMS",
  ["onetext_email_opt_in" /* EMAIL_OPT_IN */]: "opted into email",
  ["onetext_checkout_cancel" /* CHECKOUT_CANCEL */]: "canceled a text-to-buy order",
  ["onetext_external_browse" /* EXTERNAL_BROWSE */]: "browsed the site",
  ["onetext_checkout_finalize" /* CHECKOUT_FINALIZE */]: "placed an order via text-to-buy",
  ["onetext_checkout_preorder" /* CHECKOUT_PREORDER */]: "preordered via text-to-buy",
  ["onetext_checkout_refund" /* CHECKOUT_REFUND */]: "received a refund",
  ["onetext_checkout_refund_delay" /* CHECKOUT_REFUND_DELAY */]: "experienced a refund delay",
  ["onetext_checkout_setup" /* CHECKOUT_SETUP */]: "started a text-to-buy order",
  ["onetext_checkout_update" /* CHECKOUT_UPDATE */]: "updated a text-to-buy order",
  ["onetext_experiment_start" /* EXPERIMENT_START */]: "started an experiment",
  ["onetext_experiment_end" /* EXPERIMENT_END */]: "ended an experiment",
  ["onetext_external_cart_update" /* EXTERNAL_CART_UPDATE */]: "updated an online cart",
  ["onetext_external_checkout_update" /* EXTERNAL_CHECKOUT_UPDATE */]: "updated an online checkout",
  ["onetext_external_order_shipped" /* EXTERNAL_ORDER_SHIPPED */]: "had an order shipped",
  ["onetext_external_product_view" /* EXTERNAL_PRODUCT_VIEW */]: "viewed a product",
  ["onetext_sms_opt_in_request" /* SMS_OPT_IN_REQUEST */]: "was requested to opt-in",
  ["onetext_sms_response" /* SMS_RESPONSE */]: "responded to an SMS",
  ["onetext_message_outbound" /* MESSAGE_OUTBOUND */]: "received any OneText message",
  ["onetext_activate_subscription" /* SUBSCRIPTION_ACTIVATE */]: "activated a OneText refill",
  ["onetext_subscription_cancel" /* SUBSCRIPTION_CANCEL */]: "canceled a OneText refill",
  ["onetext_vault_finalize" /* VAULT_FINALIZE */]: "vaulted a payment method",
  ["onetext_popup_sms_opt_in" /* POPUP_SMS_OPT_IN */]: "opted in to SMS in a popup",
  ["onetext_popup_email_opt_in" /* POPUP_EMAIL_OPT_IN */]: "opted in to email in a popup",
  ["onetext_popup_quiz_result" /* POPUP_QUIZ_RESULT */]: "completed a quiz in a popup"
};
export const CUSTOM_TRIGGERABLE_BUYER_EVENT = {
  ["onetext_checkout_cancel" /* CHECKOUT_CANCEL */]: "onetext_checkout_cancel" /* CHECKOUT_CANCEL */,
  ["onetext_checkout_finalize" /* CHECKOUT_FINALIZE */]: "onetext_checkout_finalize" /* CHECKOUT_FINALIZE */,
  ["onetext_checkout_preorder" /* CHECKOUT_PREORDER */]: "onetext_checkout_preorder" /* CHECKOUT_PREORDER */,
  ["onetext_checkout_refund" /* CHECKOUT_REFUND */]: "onetext_checkout_refund" /* CHECKOUT_REFUND */,
  ["onetext_email_opt_in" /* EMAIL_OPT_IN */]: "onetext_email_opt_in" /* EMAIL_OPT_IN */,
  ["onetext_external_cart_create" /* EXTERNAL_CART_CREATE */]: "onetext_external_cart_create" /* EXTERNAL_CART_CREATE */,
  ["onetext_external_cart_update" /* EXTERNAL_CART_UPDATE */]: "onetext_external_cart_update" /* EXTERNAL_CART_UPDATE */,
  ["onetext_external_checkout_create" /* EXTERNAL_CHECKOUT_CREATE */]: "onetext_external_checkout_create" /* EXTERNAL_CHECKOUT_CREATE */,
  ["onetext_external_checkout_update" /* EXTERNAL_CHECKOUT_UPDATE */]: "onetext_external_checkout_update" /* EXTERNAL_CHECKOUT_UPDATE */,
  ["onetext_external_order_create" /* EXTERNAL_ORDER_CREATE */]: "onetext_external_order_create" /* EXTERNAL_ORDER_CREATE */,
  ["onetext_external_order_shipped" /* EXTERNAL_ORDER_SHIPPED */]: "onetext_external_order_shipped" /* EXTERNAL_ORDER_SHIPPED */,
  ["onetext_external_product_view" /* EXTERNAL_PRODUCT_VIEW */]: "onetext_external_product_view" /* EXTERNAL_PRODUCT_VIEW */,
  ["onetext_external_browse" /* EXTERNAL_BROWSE */]: "onetext_external_browse" /* EXTERNAL_BROWSE */,
  ["onetext_link_click" /* LINK_CLICK */]: "onetext_link_click" /* LINK_CLICK */,
  ["onetext_sms_opt_in" /* SMS_OPT_IN */]: "onetext_sms_opt_in" /* SMS_OPT_IN */,
  ["onetext_sms_opt_out" /* SMS_OPT_OUT */]: "onetext_sms_opt_out" /* SMS_OPT_OUT */,
  ["onetext_sms_response" /* SMS_RESPONSE */]: "onetext_sms_response" /* SMS_RESPONSE */,
  ["onetext_activate_subscription" /* SUBSCRIPTION_ACTIVATE */]: "onetext_activate_subscription" /* SUBSCRIPTION_ACTIVATE */,
  ["onetext_subscription_cancel" /* SUBSCRIPTION_CANCEL */]: "onetext_subscription_cancel" /* SUBSCRIPTION_CANCEL */,
  ["onetext_popup_sms_opt_in" /* POPUP_SMS_OPT_IN */]: "onetext_popup_sms_opt_in" /* POPUP_SMS_OPT_IN */,
  ["onetext_popup_email_opt_in" /* POPUP_EMAIL_OPT_IN */]: "onetext_popup_email_opt_in" /* POPUP_EMAIL_OPT_IN */,
  ["onetext_popup_quiz_result" /* POPUP_QUIZ_RESULT */]: "onetext_popup_quiz_result" /* POPUP_QUIZ_RESULT */
};
export var BUYER_EVENT_PAYLOAD_KEY = /* @__PURE__ */ ((BUYER_EVENT_PAYLOAD_KEY2) => {
  BUYER_EVENT_PAYLOAD_KEY2["ORDER_TAGS"] = "tags";
  BUYER_EVENT_PAYLOAD_KEY2["ORDER_INPUT"] = "orderInput";
  BUYER_EVENT_PAYLOAD_KEY2["PRODUCT_TAGS"] = "productTags";
  BUYER_EVENT_PAYLOAD_KEY2["PRODUCT_COLLECTIONS"] = "productCollections";
  BUYER_EVENT_PAYLOAD_KEY2["KEYWORD"] = "keyword";
  BUYER_EVENT_PAYLOAD_KEY2["SHORT_ID"] = "shortID";
  BUYER_EVENT_PAYLOAD_KEY2["SUBTOTAL"] = "subtotal";
  return BUYER_EVENT_PAYLOAD_KEY2;
})(BUYER_EVENT_PAYLOAD_KEY || {});
export var MERCHANT_CHECKPOINT = /* @__PURE__ */ ((MERCHANT_CHECKPOINT2) => {
  MERCHANT_CHECKPOINT2["MERCHANT_LOGIN"] = "merchant_login";
  MERCHANT_CHECKPOINT2["MERCHANT_LAUNCH_CAMPAIGN"] = "merchant_launch_campaign";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_WELCOME_FLOW"] = "merchant_enable_welcome_flow";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_WELCOME_FLOW"] = "merchant_disable_welcome_flow";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_CART_CONCIERGE"] = "merchant_enable_cart_concierge";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_CART_CONCIERGE"] = "merchant_disable_cart_concierge";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_ORDER_RECOVERY"] = "merchant_enable_order_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_ORDER_RECOVERY"] = "merchant_disable_order_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_PRODUCT_VIEW_RECOVERY"] = "merchant_enable_product_view_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_PRODUCT_VIEW_RECOVERY"] = "merchant_disable_product_view_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_BROWSE_RECOVERY"] = "merchant_enable_browse_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_BROWSE_RECOVERY"] = "merchant_disable_browse_recovery";
  MERCHANT_CHECKPOINT2["MERCHANT_ENABLE_POST_PURCHASE_UPSELL"] = "merchant_enable_post_purchase_upsell";
  MERCHANT_CHECKPOINT2["MERCHANT_DISABLE_POST_PURCHASE_UPSELL"] = "merchant_disable_post_purchase_upsell";
  MERCHANT_CHECKPOINT2["MERCHANT_VAULTED_CARD"] = "merchant_vaulted_card";
  return MERCHANT_CHECKPOINT2;
})(MERCHANT_CHECKPOINT || {});
export var ATTRIBUTION_CAUSE = /* @__PURE__ */ ((ATTRIBUTION_CAUSE2) => {
  ATTRIBUTION_CAUSE2["INTERNAL_ORDER"] = "internal_checkout";
  ATTRIBUTION_CAUSE2["OUTBOUND_MESSAGE"] = "outgoing_message";
  ATTRIBUTION_CAUSE2["LINK_CLICK"] = "link_click";
  return ATTRIBUTION_CAUSE2;
})(ATTRIBUTION_CAUSE || {});
export var ATTRIBUTION_EVENT = /* @__PURE__ */ ((ATTRIBUTION_EVENT2) => {
  ATTRIBUTION_EVENT2["FLOW_START"] = "flow_start";
  ATTRIBUTION_EVENT2["MESSAGE_OUTBOUND"] = "message_outbound";
  ATTRIBUTION_EVENT2["LINK_CLICK"] = "link_click";
  ATTRIBUTION_EVENT2["INTERNAL_ORDER"] = "internal_order";
  ATTRIBUTION_EVENT2["EXTERNAL_ORDER"] = "external_order";
  ATTRIBUTION_EVENT2["OPT_OUT"] = "opt_out";
  return ATTRIBUTION_EVENT2;
})(ATTRIBUTION_EVENT || {});
export var DEVICE_ID_TYPE = /* @__PURE__ */ ((DEVICE_ID_TYPE2) => {
  DEVICE_ID_TYPE2["USER_ID"] = "user_id";
  DEVICE_ID_TYPE2["DEFAULT"] = "default";
  DEVICE_ID_TYPE2["PHONE"] = "phone";
  DEVICE_ID_TYPE2["EMAIL"] = "email";
  DEVICE_ID_TYPE2["SHOPIFY_CART_TOKEN"] = "shopify_cart_token";
  return DEVICE_ID_TYPE2;
})(DEVICE_ID_TYPE || {});
export var SERVICE_NAME = /* @__PURE__ */ ((SERVICE_NAME2) => {
  SERVICE_NAME2["API"] = "onetext-api";
  SERVICE_NAME2["WORKER"] = "onetext-worker";
  SERVICE_NAME2["UNKNOWN"] = "unknown-service";
  return SERVICE_NAME2;
})(SERVICE_NAME || {});
export var TRACE_SPAN_TAG = /* @__PURE__ */ ((TRACE_SPAN_TAG2) => {
  TRACE_SPAN_TAG2["CONTEXT_ID"] = "context.id";
  TRACE_SPAN_TAG2["CONTEXT_ACCOUNT_ID"] = "context.account_id";
  TRACE_SPAN_TAG2["HOST"] = "host";
  TRACE_SPAN_TAG2["RESOURCE_NAME"] = "resource.name";
  TRACE_SPAN_TAG2["TASK_ID"] = "payload.task.id";
  TRACE_SPAN_TAG2["TASK_METADATA"] = "payload.task.metadata";
  TRACE_SPAN_TAG2["TASK_TYPE"] = "payload.task.type";
  TRACE_SPAN_TAG2["TASK_LABEL"] = "payload.task.label";
  TRACE_SPAN_TAG2["SHOPIFY_WEBHOOK_ID"] = "payload.shopify_webhook_id";
  return TRACE_SPAN_TAG2;
})(TRACE_SPAN_TAG || {});
export var TRACKING_EVENT_TYPE = /* @__PURE__ */ ((TRACKING_EVENT_TYPE2) => {
  TRACKING_EVENT_TYPE2["CORE_EVENT"] = "core_event";
  TRACKING_EVENT_TYPE2["CUSTOM_EVENT"] = "custom_event";
  TRACKING_EVENT_TYPE2["REQUEST"] = "request";
  TRACKING_EVENT_TYPE2["TASK"] = "task";
  TRACKING_EVENT_TYPE2["CHECKOUT"] = "checkout";
  TRACKING_EVENT_TYPE2["SUBSCRIPTION"] = "subscription";
  TRACKING_EVENT_TYPE2["MESSAGE"] = "message";
  TRACKING_EVENT_TYPE2["CORE_FLOW_INSTANCE"] = "core_flow_instance";
  TRACKING_EVENT_TYPE2["CUSTOM_FLOW_INSTANCE"] = "custom_flow_instance";
  return TRACKING_EVENT_TYPE2;
})(TRACKING_EVENT_TYPE || {});
export const UTM_MEDIUM_DEFAULT_VALUE = "SMS";
export const UTM_SOURCE_DEFAULT_VALUE = "OneText";
